(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_banner-parent"] && !Shopify.designMode) return;
  try {
    function initBannerGrid() {
    const bannerParents = document.querySelectorAll('.banner-parent');
    bannerParents.forEach(function (bannerParent) {
      const bannerItems = bannerParent.querySelectorAll('.banner-item');
      bannerParent.classList.add('grid-' + bannerItems.length);
    });
  }

  initBannerGrid();  
  if (Shopify.designMode || Shopify.visualPreviewMode) {
    document.addEventListener('shopify:section:select', initBannerGrid);
    document.addEventListener('shopify:section:deselect', initBannerGrid);
    document.addEventListener('shopify:section:reorder', initBannerGrid);
    document.addEventListener('shopify:block:select', initBannerGrid);
    document.addEventListener('shopify:block:deselect', initBannerGrid);
    document.addEventListener('shopify:section:load', initBannerGrid);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-variation-table"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    function init(block) {
      if (block.dataset.vtInitialized === 'true') return;
      block.dataset.vtInitialized = 'true';

      var rowsBody = block.querySelector('[data-vt-rows]');
      var searchInput = block.querySelector('[data-vt-search]');
      var addToCartBtn = block.querySelector('[data-vt-add-to-cart]');
      var messageEl = block.querySelector('[data-vt-message]');
      var sortState = { key: null, dir: 1 };

      if (!rowsBody) return;
      function updateSummary() {
        var count = 0, packs = 0, total = 0;
        block.querySelectorAll('[data-vt-qty-input]').forEach(function (input) {
          var qty = Math.max(0, parseInt(input.value, 10) || 0);
          if (qty) count++;
          packs += qty;
          total += qty * (Number(input.closest('[data-vt-row]').dataset.price) || 0);
        });
        block.querySelector('[data-vt-selected]').textContent = count;
        block.querySelector('[data-vt-packs]').textContent = packs;
        var totalEl = block.querySelector('[data-vt-total]');
        if (totalEl) totalEl.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:block.dataset.currency}).format(total / 100);
        if (!addToCartBtn.classList.contains('vt-loading')) addToCartBtn.disabled = packs === 0;
      }
      block.addEventListener('input', updateSummary);
      block.addEventListener('change', updateSummary);
      updateSummary();
      async function loadRemaining() {
        var next = block.querySelector('[data-vt-next]');
        while (next) {
          try {
            var url = new URL(next.href, location.origin);
            url.searchParams.set('section_id', block.dataset.sectionId);
            var response = await fetch(url, {credentials:'same-origin'});
            if (!response.ok) return;
            var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            var incoming = doc.getElementById(block.id);
            if (!incoming) return;
            incoming.querySelectorAll('[data-vt-row]').forEach(function(row) { rowsBody.appendChild(row); });
            var replacement = incoming.querySelector('[data-vt-next]');
            next.remove();
            if (replacement) block.querySelector('.vt-table-scroll').appendChild(replacement);
            next = replacement;
            if (searchInput) searchInput.dispatchEvent(new Event('input'));
          } catch (error) { return; }
        }
      }
      loadRemaining();

      
      function findMatchingSwatch(basename) {
        if (!basename) return null;
        var candidates = document.querySelectorAll('[data-image]');
        for (var i = 0; i < candidates.length; i++) {
          var el = candidates[i];
          var raw = el.getAttribute('data-image') || '';
          var noQuery = raw.split('?')[0];
          var bn = noQuery.substring(noQuery.lastIndexOf('/') + 1);
          if (bn === basename) return el;
        }
        return null;
      }

      function previewVariantMedia(mediaId, imageFile) {
        var target = null;

        if (mediaId) {
          document.querySelectorAll('[data-media-id]').forEach(function (el) {
            if (target) return;
            var attr = el.getAttribute('data-media-id') || '';
            var trailing = attr.substring(attr.lastIndexOf('-') + 1);
            if (trailing === String(mediaId) && el.closest('media-gallery')) {
              target = el;
            }
          });
        }

        if (target) {
          var slideEl = target.closest('.swiper-slide') || target;
          var gallery = target.closest('media-gallery');
          var mainSwiperEl = gallery ? gallery.querySelector('.swiper-wrapper-preview.swiper') : null;
          var mainSwiper = mainSwiperEl && mainSwiperEl.swiper;

          if (mainSwiper && typeof mainSwiper.slideTo === 'function' && mainSwiper.slides && mainSwiper.slides.length) {
            var slides = Array.prototype.slice.call(mainSwiper.slides);
            var idx = slides.indexOf(slideEl);
            if (idx < 0 && gallery) {
              var gallerySlides = Array.prototype.slice.call(gallery.querySelectorAll('.media-main-swiper .swiper-slide'));
              idx = gallerySlides.indexOf(slideEl);
            }
            if (idx > -1) {
              mainSwiper.slideTo(idx);
              return;
            }
          }

          if (gallery) {
            var gallerySlides = Array.prototype.slice.call(gallery.querySelectorAll('.media-main-swiper .swiper-slide'));
            var fallbackIndex = gallerySlides.indexOf(slideEl);
            var thumbSlides = gallery.querySelectorAll('.thumbnail-slide .swiper-slide');
            if (fallbackIndex > -1 && thumbSlides[fallbackIndex]) {
              thumbSlides[fallbackIndex].click();
              return;
            }
          }

          slideEl.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
          slideEl.classList.add('vt-media-highlight');
          window.setTimeout(function () {
            slideEl.classList.remove('vt-media-highlight');
          }, 900);
          return;
        }

        var swatchEl = findMatchingSwatch(imageFile);
        if (swatchEl) {
          var clickTarget = swatchEl;
          if (swatchEl.tagName !== 'LABEL') {
            var forId = swatchEl.id ? document.querySelector('label[for="' + swatchEl.id + '"]') : null;
            clickTarget = swatchEl.closest('label') || forId || swatchEl;
          }
          clickTarget.click();
        }
      }

      function activateRow(row) {
        if (!row) return;
        previewVariantMedia(row.getAttribute('data-vt-media-id'), row.getAttribute('data-vt-image-file'));
        rowsBody.querySelectorAll('[data-vt-row]').forEach(function (r) {
          r.classList.remove('vt-row-active');
        });
        row.classList.add('vt-row-active');
      }

      block.addEventListener('click', function (event) {
        var row = event.target.closest('[data-vt-row]');
        if (!row) return;
        activateRow(row);
      });

      
      block.addEventListener('click', function (event) {
        var decBtn = event.target.closest('[data-vt-decrement]');
        var incBtn = event.target.closest('[data-vt-increment]');
        if (!decBtn && !incBtn) return;

        var stepper = (decBtn || incBtn).closest('[data-vt-stepper]');
        var input = stepper.querySelector('[data-vt-qty-input]');
        var value = parseInt(input.value, 10);
        if (isNaN(value)) value = 0;

        if (decBtn) value = Math.max(0, value - 1);
        if (incBtn) value = value + 1;

        var max = input.getAttribute('data-max');
        if (max !== null && max !== '') {
          value = Math.min(value, parseInt(max, 10));
        }

        input.value = value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      block.addEventListener('change', function (event) {
        var input = event.target.closest('[data-vt-qty-input]');
        if (!input) return;

        var value = parseInt(input.value, 10);
        if (isNaN(value) || value < 0) value = 0;

        var max = input.getAttribute('data-max');
        if (max !== null && max !== '') {
          value = Math.min(value, parseInt(max, 10));
        }

        input.value = Math.max(0, value);
        activateRow(input.closest('[data-vt-row]'));
        updateSummary();
      });

      
      if (searchInput) {
        searchInput.addEventListener('input', function () {
          var term = searchInput.value.trim().toLowerCase();
          var rows = rowsBody.querySelectorAll('[data-vt-row]');
          rows.forEach(function (row) {
            var haystack = row.getAttribute('data-search') || '';
            row.hidden = term.length > 0 && haystack.indexOf(term) === -1;
          });
        });
      }

      
      block.querySelectorAll('[data-vt-sort]').forEach(function (th) {
        th.addEventListener('keydown', function(event) { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); th.click(); } });
        th.addEventListener('click', function () {
          var key = th.getAttribute('data-vt-sort');
          if (sortState.key === key) {
            sortState.dir = sortState.dir * -1;
          } else {
            sortState.key = key;
            sortState.dir = 1;
          }

          block.querySelectorAll('[data-vt-sort]').forEach(function (h) {
            h.classList.remove('vt-sort-asc', 'vt-sort-desc');
          });
          th.classList.add(sortState.dir === 1 ? 'vt-sort-asc' : 'vt-sort-desc');

          var rows = Array.prototype.slice.call(rowsBody.querySelectorAll('[data-vt-row]'));
          rows.sort(function (a, b) {
            var av, bv;
            if (key === 'stock') {
              av = parseFloat(a.getAttribute('data-stock'));
              bv = parseFloat(b.getAttribute('data-stock'));
            } else if (key === 'order') {
              av = parseFloat(a.getAttribute('data-order'));
              bv = parseFloat(b.getAttribute('data-order'));
            } else {
              av = a.getAttribute('data-title') || '';
              bv = b.getAttribute('data-title') || '';
              return sortState.dir * av.localeCompare(bv, undefined, {numeric:true});
            }
            return sortState.dir * (av - bv);
          });

          rows.forEach(function (row) {
            rowsBody.appendChild(row);
          });
        });
      });

      
      if (addToCartBtn) {
        addToCartBtn.addEventListener('click', function () {
          var items = [];
          var firstSelectedRow = null;
          block.querySelectorAll('[data-vt-qty-input]').forEach(function (input) {
            var qty = parseInt(input.value, 10);
            if (qty > 0) {
              if (!firstSelectedRow) firstSelectedRow = input.closest('[data-vt-row]');
              items.push({
                id: parseInt(input.getAttribute('data-variant-id'), 10),
                quantity: qty
              });
            }
          });
          if (firstSelectedRow) activateRow(firstSelectedRow);

          if (items.length === 0) {
            showMessage(messageEl, block.dataset.emptyMessage, true);
            return;
          }

          setLoading(addToCartBtn, true);

          fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'cart/add.js'
            : '/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ items: items })
          })
            .then(function (response) {
              return response.json().then(function (data) {
                return { ok: response.ok, data: data };
              });
            })
            .then(function (result) {
              setLoading(addToCartBtn, false);
              if (!result.ok) {
                var description = result.data && result.data.description
                  ? result.data.description
                  : block.dataset.errorMessage;
                showMessage(messageEl, description, true);
                return;
              }

              showMessage(messageEl, block.dataset.successMessage, false);

              block.querySelectorAll('[data-vt-qty-input]').forEach(function (input) {
                input.value = 0;
              });

              updateSummary();
              window.location.assign(block.dataset.cartUrl);
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
            })
            .catch(function () {
              setLoading(addToCartBtn, false);
              showMessage(messageEl, block.dataset.errorMessage, true);
            });
        });
      }
    }

    function setLoading(button, isLoading) {
      button.disabled = isLoading;
      button.classList.toggle('vt-loading', isLoading);
    }

    function showMessage(el, text, isError) {
      if (!el) return;
      el.textContent = text;
      el.hidden = false;
      el.classList.toggle('vt-message-error', !!isError);
      el.classList.toggle('vt-message-success', !isError);
      window.clearTimeout(el._vtTimeout);
      el._vtTimeout = window.setTimeout(function () {
        el.hidden = true;
      }, 4000);
    }

    function initAll() {
      document.querySelectorAll('[data-vt-block]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    
    document.addEventListener('shopify:section:load', function (event) {
      var block = event.target && event.target.querySelector
        ? event.target.querySelector('[data-vt-block]')
        : null;
      if (block) init(block);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_slide-parent"] && !Shopify.designMode) return;
  try {
    function addAnimateDelayToSlides() {
    const swiperWrappers = document.querySelectorAll('.swiper-wrapper_parent');
    swiperWrappers.forEach(function(swiperWrapper) {
      const slideItems = swiperWrapper.querySelectorAll('.swiper-slide_item');
      slideItems.forEach(function(slideItem, index) {
        if (index > 0) {
          const contentSlides = slideItem.querySelectorAll('.content-slide');
          contentSlides.forEach(function(contentSlide) {
            contentSlide.classList.add('animate-delay');
          });
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', addAnimateDelayToSlides);
  if (Shopify.designMode || Shopify.visualPreviewMode) {
    document.addEventListener('shopify:section:select', addAnimateDelayToSlides);
    document.addEventListener('shopify:section:deselect', addAnimateDelayToSlides);
    document.addEventListener('shopify:section:reorder', addAnimateDelayToSlides);
    document.addEventListener('shopify:block:select', addAnimateDelayToSlides);
    document.addEventListener('shopify:block:deselect', addAnimateDelayToSlides);
    document.addEventListener('shopify:section:load', addAnimateDelayToSlides);
  }
  } catch(e) { console.error(e); }
})();

})();
